module.exports = __webpack_public_path__ + "static/process_img_card3-6d316bcfcaef0dcdc81878ce00f68b8f.png";